export default {
    title: 'Total Employee',
    weekly: 'Weekly',
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    sun: 'Sun',
    present: 'Present',
    late: 'Late'
}
